import React from 'react';

import styles from './realPhotoV2.module.scss';

import realPhotoV2Female1 from './img/realV2-female-before.jpg';
import realPhotoV2Female2 from './img/realV2-female-after.jpg';
import realPhotoV2Male1 from './img/realV2-male-before.jpg';
import realPhotoV2Male2 from './img/realV2-male-after.jpg';
import { useT } from '@hooks';
import { appStore } from '@store';
import checkTheme from '../../../../../../../src/utils/custom/checkTheme';

const RealPhotoV2 = () => {
	const { T } = useT();
	let gender = appStore.params.gender;
	let imgSrcBefore = realPhotoV2Female1;
	let imgSrcAfter = realPhotoV2Female2;
	const textData = [
		{
			title: T('realPhotoV2_title_female'),
			description: T('realPhotoV2_description_female'),
			weightBefore: T('realPhotoV2_title_female_before'),
			weightAfter: T('realPhotoV2_title_female_after'),
		},
		{
			title: T('realPhotoV2_title_male'),
			description: T('realPhotoV2_description_male'),
			weightBefore: T('realPhotoV2_title_male_before'),
			weightAfter: T('realPhotoV2_title_male_after'),
		},
	];

	let title = textData[0].title;
	let description = textData[0].description;
	let weightBefore = textData[0].weightBefore;
	let weightAfter = textData[0].weightAfter;

	if (gender === 'other') gender = 'female';
	if (gender === 'male') {
		imgSrcBefore = realPhotoV2Male1;
		imgSrcAfter = realPhotoV2Male2;
		title = textData[1].title;
		description = textData[1].description;
		weightBefore = textData[1].weightBefore;
		weightAfter = textData[1].weightAfter;
	}
	return (
		<div className={`${styles.realPhotoV2_container} ${styles[checkTheme()]}`}>
			<div className={styles.realPhotoV2_imgs}>
				<div className={styles.realPhotoV2_imgWrapper}>
					<img className={styles.realPhotoV2_imgWrapper_img} src={imgSrcBefore} alt='before' />
					<div className={styles.realPhotoV2_weight}>{weightBefore}</div>
				</div>
				<div className={styles.realPhotoV2_imgWrapper}>
					<img className={styles.realPhotoV2_imgWrapper_img} src={imgSrcAfter} alt='after' />
					<div className={styles.realPhotoV2_weight_after}>{weightAfter}</div>
				</div>
			</div>
			<div className={styles.realPhotoV2_title}>{title}</div>
			<div className={styles.realPhotoV2_description}>{description}</div>
		</div>
	);
};

export default RealPhotoV2;
